export default __webpack_public_path__ + "static/media/upload-Image-image.d0074630.svg";